import React from 'react'
import PropTypes from 'prop-types'

import View from '../ViewComponents/View'

import s from './Walktrough.css'

const POSITIONS = {
  TOP_RIGHT: 'top-right',
  TOP_LEFT: 'top-left',
  BOTTOM_RIGHT: 'bottom-right',
  BOTTOM_LEFT: 'bottom-left',
  LEFT_TOP: 'left-top',
  LEFT_BOTTOM: 'left-bottom',
  RIGHT_TOP: 'right-top',
  RIGHT_BOTTOM: 'right-bottom',
  FLOATING: 'floating'
}

const TOOLTIP_ID = 'tooltip'

const TOOLTIP_MINWIDTH = 150
const TOOLTIP_MAXWIDTH = 400
const TOOLTIP_MAXHEIGHT = 300
const TOOLTOP_MINHEIGHT = 90

const DATA_KEY = 'erv-geomaps-data'

const timeout = async (ms = 0) => {
  return new Promise(resolve => setTimeout(resolve, ms))
}

class Walkthrough extends React.Component {

  constructor (props) {
    super(props)

    this.state = {
      index: 0,
      steps: [],
      tooltipHeight: TOOLTIP_MAXHEIGHT,
      tooltipWidth: TOOLTIP_MAXWIDTH,
      finished: false,
      goingBack: false,
      goingForward: false,
      init: true,
      styles: {}
    }

    this.retriedCalculatedStyles = false

    this.filterSteps(props.steps).then(steps => {
      if (!steps || steps.length === 0) {
        props.onExit()
      }
      else {
        this.setState({steps})
      }
    })
  }

  componentDidMount () {
    const tooltip = document.getElementById(TOOLTIP_ID)
    this.recalculateOnComponentUpdate(tooltip)
  }

  componentDidUpdate (prevProps, prevState) {
    this.onComponentUpdate(prevProps, prevState)
  }

  onComponentUpdate (prevProps, prevState, isDelayedTry = false) {
    if (this.state.init) {
      const tooltip = document.getElementById(TOOLTIP_ID)

      if (tooltip && (Math.abs(tooltip.offsetHeight - prevState.tooltipHeight) > 3 || Math.abs(tooltip.offsetWidth - prevState.tooltipWidth) > 3 || this.state.index !== prevState.index)) {
        this.recalculateOnComponentUpdate(tooltip)
      }

      // it may be that the update is called but the ui is not updated yet so let's recalculate in a moment
      else if (!isDelayedTry) {
        setTimeout(() => {
          this.onComponentUpdate(prevProps, prevState, true)
        }, 500)
      }
    }
    else {
      const tooltip = document.getElementById(TOOLTIP_ID)
      // console.log('tooltip', tooltip.offsetHeight, prevState.tooltipHeight, tooltip.offsetWidth, prevState.tooltipWidth)

      if (tooltip && (Math.abs(tooltip.offsetHeight - prevState.tooltipHeight) > 3 || Math.abs(tooltip.offsetWidth - prevState.tooltipWidth) > 3 || this.state.index !== prevState.index)) {
        const styles = this.calculateStyles()
        setTimeout(() => {
          this.setState({styles, tooltipHeight: tooltip.offsetHeight, tooltipWidth: tooltip.offsetWidth})
        })
      }

      // it may be that the update is called but the ui is not updated yet so let's recalculate in a moment
      else if (!isDelayedTry) {
        setTimeout(() => {
          this.onComponentUpdate(prevProps, prevState, true)
        }, 500)
      }
    }
  }

  recalculateOnComponentUpdate (tooltip) {
    if (this.state.steps.length === 0) {
      return
    }
    // console.log('recalculateOnComponentUpdate')
    const nextStateToSet = {}
    nextStateToSet.styles = this.calculateStyles()
    nextStateToSet.tooltipHeight = tooltip.offsetHeight
    nextStateToSet.tooltipWidth = tooltip.offsetWidth
    setTimeout(() => {
      this.setState(nextStateToSet)
    })
  }

  async filterSteps (steps, retryCount = 0) {
    if (retryCount > 20) {
      return Promise.reject('waited too long for Kesi Tools')
    }
    if (window.KesiTools) {
      if (retryCount > 0 && !window.KesiTools.runsInIframe()){
        return steps
      }
      window.KesiTools.reloadValues()
      if (!window.KesiTools.dataLoaded()) {
        await timeout(100)
        return this.filterSteps(steps, retryCount + 1)
      }
      const savedData = window.KesiTools.getValue(DATA_KEY)
      // console.log('savedData', savedData)
      if (savedData) {
        const filteredSteps = steps.filter(step => savedData[step.element] !== true)
        // console.log('filteredSteps', filteredSteps)
        return filteredSteps
      }
      return steps
    }
    else {
      await timeout(((retryCount + 1) * 10) ** 2)
      return this.filterSteps(steps, retryCount + 1)
    }
    // console.log('use all steps')
    // return steps
  }

  removeEntry = (stringArray, stringToRemove) => {
    if (stringArray.indexOf(stringToRemove) > -1) {
      stringArray.splice(stringArray.indexOf(stringToRemove), 1)
    }
  }

  getWinSize = () => {
    if (window.innerWidth !== 'undefined') {
      return {width: window.innerWidth, height: window.innerHeight}
    } else {
      const doc = document.documentElement
      return {width: doc.clientWidth, height: doc.clientHeight}
    }
  }

  calculateStyles = (run = 0) => {

    let tooltipStyle = {}
    let tooltipInnerStyle = {}
    let arrowClassName = ''
    let arrowStyles = {}
    let overlayHoleStyle = {}

    if (!this.state.finished && this.state.steps && this.state.steps.length > 0 && this.state.steps.length >= this.state.index) {
      const windowSize = this.getWinSize()
      const currentStep = this.state.steps[this.state.index]

      this.props.showSettingsWithId(currentStep.settingsId ? currentStep.settingsId : '')

      let targetElement = null

      if (currentStep.element) {
        if (currentStep.element.startsWith('.')) {
          const targetClassElements = document.getElementsByClassName(currentStep.element.substring(1))

          if (targetClassElements.length > 0) {
            targetElement = targetClassElements[0]
          }
        }
        else if (currentStep.element.startsWith('#')) {
          targetElement = document.getElementById(currentStep.element.substring(1))
        }
        else {
          targetElement = document.getElementById(currentStep.element.substring(1))

          if (!targetElement) {
            const targetClassElements = document.getElementsByClassName(currentStep.element)

            if (targetClassElements.length > 0) {
              targetElement = targetClassElements[0]
            }
          }
        }
      }

      if (targetElement) {

        const targetElementRect = targetElement.getBoundingClientRect()

        overlayHoleStyle = {
          left: `${targetElementRect.left - 20}px`,
          top: `${targetElementRect.top - 20}px`,
          width: `${targetElementRect.right - targetElementRect.left}px`,
          height: `${targetElementRect.bottom - targetElementRect.top}px`
        }

        let possiblePositions = Object.values(POSITIONS)

        // If we check all the possible areas, and there are no valid places for the tooltip, the element
        // must take up most of the screen real estate. Show the tooltip floating in the middle of the screen.
        let calculatedPosition = 'floating'
        const desiredTooltipPosition = this.state.steps[this.state.index].position

        // Check for space below (and left)
        if (windowSize.width - targetElementRect.left < 50 || (targetElementRect.bottom + TOOLTOP_MINHEIGHT + 96 > windowSize.height)) {
          console.warn('bottom-left not available')
          this.removeEntry(possiblePositions, 'bottom-left')
        }

        // Check for space below (and right)
        if (windowSize.width - targetElementRect.right < 50 || (targetElementRect.bottom + TOOLTOP_MINHEIGHT + 96 > windowSize.height)) {
          console.warn('bottom-right not available')
          this.removeEntry(possiblePositions, 'bottom-right')
        }

        // Check for space above (and left)
        if (windowSize.width - targetElementRect.left < 50 || (targetElementRect.top - TOOLTOP_MINHEIGHT - 96 < 0)) {
          console.warn('top-left not available')
          this.removeEntry(possiblePositions, 'top-left')
        }

        // Check for space above (and right)
        if (windowSize.width - targetElementRect.right < 50 || (targetElementRect.top - TOOLTOP_MINHEIGHT - 96 < 0)) {
          console.warn('top-right not available')
          this.removeEntry(possiblePositions, 'top-right')
        }

        // Check for space to the right + 125 ( 105 for the arrow and 20 for padding)
        // TODO: Check 50px Value!
        if (windowSize.height - targetElementRect.top < 50 || targetElementRect.right + TOOLTIP_MINWIDTH + 135 > windowSize.width) {
          console.warn('right-bottom not available')
          this.removeEntry(possiblePositions, 'right-top')
        }

        // TODO: Check 50px Value!
        if (windowSize.height - targetElementRect.bottom < 50 || targetElementRect.right + TOOLTIP_MINWIDTH + 135 > windowSize.width) {
          console.warn('right-bottom not available')
          this.removeEntry(possiblePositions, 'right-bottom')
        }

        // Check for space to the left -145 -> 105 for the arrow, 40 for padding
        // TODO: Check 50px Value!
        if (windowSize.height - targetElementRect.top < 50 || targetElementRect.left - TOOLTIP_MINWIDTH - 135 < 0) {
          console.warn('left-top not available')
          this.removeEntry(possiblePositions, 'left-top')
        }

        // Check for space to the left -145 -> 105 for the arrow, 40 for padding
        // TODO: Check 50px Value!
        if (windowSize.height - targetElementRect.bottom < 50 || targetElementRect.left - TOOLTIP_MINWIDTH - 135 < 0) {
          console.warn('left-bottom not available')
          this.removeEntry(possiblePositions, 'left-bottom')
        }

        if (possiblePositions.length) {
          if (desiredTooltipPosition !== 'auto' &&
            possiblePositions.indexOf(desiredTooltipPosition) > -1) {
            // If the requested position is in the list, choose that
            calculatedPosition = desiredTooltipPosition
          } else {
            // Pick the first valid position, in order
            calculatedPosition = possiblePositions[0]
          }
        }

        if (calculatedPosition === POSITIONS.TOP_RIGHT) {
          const maxWidth = Math.max(Math.min(windowSize.width - 20, TOOLTIP_MAXWIDTH), TOOLTIP_MINWIDTH)
          const left = Math.max(Math.min((targetElementRect.right - targetElementRect.left) / 2 + targetElementRect.x - (this.state.tooltipWidth / 2) + 90, (windowSize.width - maxWidth) / 2), 20)

          // console.log('top right', left, maxWidth)

          tooltipStyle = {
            top: `${targetElementRect.top - 96 - this.state.tooltipHeight}px`,
            left: `${left}px`,
            width: `${maxWidth}px`,
            maxHeight: `${TOOLTIP_MAXHEIGHT}px`
          }
          arrowClassName = s.topRight
          arrowStyles = {
            top: `${this.state.tooltipHeight}px`,
            left: targetElementRect.right < (windowSize.width / 2) ? `${targetElementRect.right + 66}px` : '50%'
          }
        }
        else if (calculatedPosition === POSITIONS.TOP_LEFT) {
          const maxWidth = Math.max(Math.min(windowSize.width - 40, TOOLTIP_MAXWIDTH), TOOLTIP_MINWIDTH)
          const left = Math.max(Math.min((targetElementRect.right - targetElementRect.left) / 2 + targetElementRect.x - (this.state.tooltipWidth / 2) - 56, (windowSize.width - maxWidth) / 2), 20)

          tooltipStyle = {
            top: `${targetElementRect.top - 96 - this.state.tooltipHeight}px`,
            left: `${left}px`,
            width: `${maxWidth}px`,
            maxHeight: `${TOOLTIP_MAXHEIGHT}px`
          }
          arrowClassName = s.topLeft
          arrowStyles = {
            top: `${this.state.tooltipHeight}px`,
            left: targetElementRect.left > (windowSize.width / 2) ? `${targetElementRect.left - 66}px` : '50%'
          }
        }
        else if (calculatedPosition === POSITIONS.BOTTOM_LEFT) {

          const maxWidth = Math.max(Math.min(windowSize.width - 40, TOOLTIP_MAXWIDTH), TOOLTIP_MINWIDTH)
          const left = Math.max(Math.min((targetElementRect.right - targetElementRect.left) / 2 + targetElementRect.x - (this.state.tooltipWidth / 2) - 38, (windowSize.width - maxWidth) / 2), 20)

          tooltipStyle = {
            top: `${targetElementRect.bottom + 106}px`,
            left: `${left}px`,
            width: `${maxWidth}px`,
            maxHeight: `${TOOLTIP_MAXHEIGHT}px`
          }
          arrowClassName = s.bottomLeft
          arrowStyles = {
            left: targetElementRect.left > (windowSize.width / 2) ? `${targetElementRect.left - 66}px` : '50%'
          }
        }
        else if (calculatedPosition === POSITIONS.BOTTOM_RIGHT) {

          const maxWidth = Math.max(Math.min(windowSize.width - 20, TOOLTIP_MAXWIDTH), TOOLTIP_MINWIDTH)
          const left = Math.max(Math.min((targetElementRect.right - targetElementRect.left) / 2 + targetElementRect.x - (this.state.tooltipWidth / 2) + 38, (windowSize.width - maxWidth) / 2), 20)

          tooltipStyle = {
            top: `${targetElementRect.bottom + 106}px`,
            left: `${left}px`,
            width: `${maxWidth}px`,
            maxHeight: `${TOOLTIP_MAXHEIGHT}px`
          }
          arrowClassName = s.bottomRight
          arrowStyles = {
            left: targetElementRect.left < (windowSize.width / 2) ? `${targetElementRect.right + 66}px` : '50%'
          }
        }
        else if (calculatedPosition === POSITIONS.LEFT_BOTTOM) {

          const left = targetElementRect.left - 125 - this.state.tooltipWidth
          const maxWidth = Math.max(Math.min(targetElementRect.left - 125, TOOLTIP_MAXWIDTH), TOOLTIP_MINWIDTH)

          tooltipStyle = {
            top: `${Math.max((targetElementRect.bottom - targetElementRect.top) / 2 + targetElementRect.y, 20)}px`,
            left: `${left}px`,
            width: `${maxWidth}px`,
            maxHeight: `${TOOLTIP_MAXHEIGHT}px`
          }
          arrowClassName = s.leftBottom
          tooltipInnerStyle = {
            marginLeft: '20px',
            marginTop: '56px'
          }
        }
        else if (calculatedPosition === POSITIONS.LEFT_TOP) {

          // console.log('left-top')

          const left = Math.max(targetElementRect.left - 125 - this.state.tooltipWidth, 20)
          const maxWidth = Math.max(Math.min(targetElementRect.left - 125 - 20, TOOLTIP_MAXWIDTH), TOOLTIP_MINWIDTH)

          tooltipStyle = {
            top: `${Math.max((targetElementRect.bottom - targetElementRect.top) / 2 + targetElementRect.y - this.state.tooltipHeight + 20, 20)}px`,
            left: `${left}px`,
            width: `${maxWidth}px`,
            maxHeight: `${TOOLTIP_MAXHEIGHT}px`
          }
          arrowClassName = s.leftTop
          tooltipInnerStyle = {
            marginTop: '56px'
          }
        }
        else if (calculatedPosition === POSITIONS.RIGHT_BOTTOM) {

          const left = Math.max(targetElementRect.right + 125, 20)
          const maxWidth = Math.max(Math.min(windowSize.width - targetElementRect.right - 125, TOOLTIP_MAXWIDTH), TOOLTIP_MINWIDTH)

          tooltipStyle = {
            top: `${Math.max((targetElementRect.bottom - targetElementRect.top) / 2 + targetElementRect.y, 20)}px`,
            left: `${left}px`,
            width: `${maxWidth}px`,
            maxHeight: `${TOOLTIP_MAXHEIGHT}px`
          }
          arrowClassName = s.rightBottom
          tooltipInnerStyle = {
            marginTop: '56px'
          }
        }
        else if (calculatedPosition === POSITIONS.RIGHT_TOP) {

          const left = Math.max(targetElementRect.right + 125, 20)
          const maxWidth = Math.max(Math.min(windowSize.width - targetElementRect.right - 125, TOOLTIP_MAXWIDTH), TOOLTIP_MINWIDTH)

          tooltipStyle = {
            top: `${Math.max((targetElementRect.bottom - targetElementRect.top) / 2 + targetElementRect.y - this.state.tooltipHeight + 20, 20)}px`,
            left: `${left}px`,
            width: `${maxWidth}px`,
            maxHeight: `${TOOLTIP_MAXHEIGHT}px`
          }
          arrowClassName = s.rightTop
          tooltipInnerStyle = {
            marginLeft: '20px',
            marginTop: '56px'
          }
        }
        else if (calculatedPosition === POSITIONS.FLOATING) {
          tooltipStyle = {
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
            maxWidth: '80%',
            maxHeight: '50%'
          }
        }
      }
      else {
        console.warn(`step element ${currentStep.element} not found on run ${run}`)

        if (run < 3) {
          setTimeout(() => { return this.calculateStyles(run + 1)}, 0)
        }
        else {
          if (this.state.goingForward && this.state.index < this.state.steps.length - 1) {
            this.setState({index: this.state.index + 1})
          }
          else if (this.state.goingBack && this.state.index > 0) {
            this.setState({index: this.state.index - 1})
          }
          else {
            this.setState({finished: true})
            this.onExit()
          }
        }
      }
    }

    const styles = {
      tooltipStyle,
      overlayHoleStyle,
      arrowClassName,
      tooltipInnerStyle,
      arrowStyles
    }

    return styles
  }

  setCurrentStepAsRead = () => {
    if (window.KesiTools) {
      const currentStep = this.state.steps[this.state.index]
      const data = window.KesiTools.getValue(DATA_KEY) || {}
      data[currentStep.element] = true
      const valuesToSet = {}
      valuesToSet[DATA_KEY] = data
      window.KesiTools.setValues(valuesToSet)
    }
  }

  setAllStepsAsRead = () => {
    if (window.KesiTools) {
      const data = window.KesiTools.getValue(DATA_KEY) || {}

      for (let i = 0; i < this.state.steps; i++) {
        const currentStep = this.state.steps[i]
        data[currentStep.element] = true
      }
      const valuesToSet = {}
      valuesToSet[DATA_KEY] = data
      window.KesiTools.setValues(valuesToSet)
    }
  }

  onExit = () => {
    this.setCurrentStepAsRead()
    this.props.onExit()
  }

  render () {
    if (this.state.steps.length === 0) {
      return null
    }

    const styles = this.state.styles

    const backButton = this.state.index > 0
      ? (
        <div
          onClick={() => {
            this.setState({
              index: this.state.index - 1,
              tooltipWidth: TOOLTIP_MAXWIDTH,
              tooltipHeight: TOOLTIP_MAXHEIGHT,
              goingBack: true,
              goingForward: false
            })
          }
          }
          className={s.prevButton}>
          <View
            config={this.props.config.prevButton}
            functions={this.props.functions}
          />
        </div>
      )
      : null

    const forwardButton = this.state.index < this.state.steps.length - 1
      ? (
        <div
          onClick={() => {
            this.setCurrentStepAsRead()
            this.setState({
              index: this.state.index + 1,
              tooltipWidth: TOOLTIP_MAXWIDTH,
              tooltipHeight: TOOLTIP_MAXHEIGHT,
              goingBack: false,
              goingForward: true
            })
          }
          }
          className={s.nextButton}>
          <View
            config={this.props.config.nextButton}
            functions={this.props.functions}
          />
        </div>
      )
      : null

    const doneButton = this.state.index === this.state.steps.length - 1
      ? (
        <div onClick={this.onExit} className={s.doneButton}>
          <View
            config={this.props.config.doneButton}
            functions={this.props.functions}
          />
        </div>
      )
      : null

    return (
      <div id='walktrough' className={s.walktrough}>
        <div className={s.overlay}>
          {this.state.index < this.state.steps.length - 1 &&
          <div className={s.closeButton} onClick={this.onExit}/>
          }
          <div id={TOOLTIP_ID} className={s.tooltip} style={styles.tooltipStyle}>
            <span className={styles.arrowClassName} style={styles.arrowStyles}/>
            <div className={s.tooltipInnerContainer} style={styles.tooltipInnerStyle}>
              <div className={`${s.tooltipInner} ${!backButton ? s.firstTooltip : ''}`}>
                <View
                  config={this.state.steps[this.state.index]}
                  functions={this.props.functions}
                />
              </div>
              <div className={s.buttonContainer}>
                {backButton}
                {forwardButton}
                {doneButton}
              </div>
            </div>

          </div>
        </div>
        <div className={s.overlayHole} style={styles.overlayHoleStyle}>
          <div className={s.overlayHoleInset}/>
        </div>
      </div>
    )
  }

}

Walkthrough.propTypes = {
  steps: PropTypes.array,
  onExit: PropTypes.func.isRequired,
  nextButtonLabel: PropTypes.string,
  prevButtonLabel: PropTypes.string,
  doneButtonLabel: PropTypes.string,
  showSettingsWithId: PropTypes.func,
  config: PropTypes.object,
  functions: PropTypes.object.isRequired,
  filterSettings: PropTypes.object.isRequired
}

Walkthrough.defaultProps = {
  nextButtonLabel: 'Nächster Tipp',
  prevButtonLabel: 'Vorheriger Tipp',
  doneButtonLabel: 'Ende'
}

export default Walkthrough



// WEBPACK FOOTER //
// ./src/components/Walkthrough/Walkthrough.js